import React, {useMemo, useState} from "react";
import {useTranslate} from "../../../hooks/translate.hook";
import {SmartTable} from "../../common/smart-table/smart-table";
import {SmartTableDataHandler} from "../../common/smart-table/smart-table.data-handler";
import {Button, Space} from "antd";
import {columnsFactory} from "./declarations.declarants.columns";
import {declarationsDeclarantsService} from "../../../services/declarations/declarations.declarants.service";
import {DeclarationsDeclarant} from "../../../models/declarations/declarations.declarants";
import {DeclarationDeclarantEditModal} from "./modal/edit/declaration.declarant.edit.modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const DeclarationsDeclarants: React.FC = () => {
    const t = useTranslate();

    const columns = useMemo(() => columnsFactory(t), []);
    const handler = useMemo(() => new SmartTableDataHandler(request => declarationsDeclarantsService.getAll(request)), []);

    const [modalShown, setModalShown] = useState<boolean>(false);
    const [modalItem, setModalItem] = useState<DeclarationsDeclarant | null>(null);

    const openModal = (item: DeclarationsDeclarant | null) => {
        setModalShown(true);
        setModalItem(item);
    }

    const closeModal = async () => {
        setModalShown(false);
        setModalItem(null);
        await handler.reloadItemsWithLastRequest();
    }

    const remove = async (item: DeclarationsDeclarant) => {
        await declarationsDeclarantsService.remove(item.id);
        await handler.reloadItemsWithLastRequest();
    }

    return (
        <Space direction={"vertical"} size={[10, 10]}>
            <Button
                type={"primary"}
                onClick={() => openModal(null)}
                icon={<FontAwesomeIcon icon={["fas", "plus"]} />}
            >
                {t('CREATE')}
            </Button>
            <SmartTable
                columns={columns}
                handler={handler}
                actions={[
                    {
                        icon: 'edit',
                        title: t('EDIT'),
                        onClick: openModal
                    },
                    {
                        icon: 'trash',
                        title: t('REMOVE'),
                        onClick: remove
                    }
                ]}
            />
            {modalShown ? (
                <DeclarationDeclarantEditModal item={modalItem} onClose={closeModal} />
            ) : null}
        </Space>
    );
};

